(function () {
	"use strict";

	var documentService = angular.module('documentService', ['ng.deviceDetector']);

	documentService.constant('preferredLanguage', bm.defaults.language);
	documentService.constant('osMapping', {
		os: {
			windows: 'Windows 10 (64bit)',
			mac: 'Macintosh OS X 10.11',
			ios: 'Windows 10 (64bit)',
			android: 'Windows 10 (64bit)',
			linux: 'Linux',
			unix: 'Linux',
			'firefox-os': 'Windows 10 (64bit)',
			'chrome-os': 'Windows 10 (64bit)',
			'windows-phone': 'Windows 10 (64bit)',
			unknown: 'Windows 10 (64bit)'
		},
		os_version: {
			'windows-3-11': 'Windows 3.11',
			'windows-95': 'Windows 95',
			'windows-me': 'Windows ME',
			'windows-98': 'Windows 98',
			'windows-ce': 'Windows 10 (64bit)',
			'windows-2000': 'Windows 2000',
			'windows-xp': 'Windows XP',
			'windows-server-2003': 'Windows Server 2003',
            'windows-server-2016': 'Windows Server 2016',
			'windows-vista': 'Windows Vista',
			'windows-7': 'Windows 7 (64 bit)',
			'windows-8-1': 'Windows 8.1 (64bit)',
			'windows-8': 'Windows 8 (64bit)',
			'windows-10': 'Windows 10 (64bit)',
			'windows-phone-7-5': 'Windows 10 (64bit)',
			'windows-phone-8-1': 'Windows 10 (64bit)',
			'windows-phone-10': 'Windows 10 (64bit)',
			'windows-nt-4-0': 'Windows NT4.0',
			'mac-os-x-15': 'Macintosh OS X 10.15',
			'mac-os-x-14': 'Macintosh OS X 10.14',
			'mac-os-x-13': 'macOS High Sierra (OS X 10.13)',
			'mac-os-x-12': 'macOS Sierra (OS X 10.12)',
			'mac-os-x-11': 'Macintosh OS X 10.11',
			'mac-os-x-10': 'Macintosh OS X 10.10',
			'mac-os-x-9': 'Macintosh OS X 10.9',
			'mac-os-x-8': 'Macintosh OS X 10.8',
			'mac-os-x-7': 'Macintosh OS X 10.7',
			'mac-os-x-6': 'Macintosh OS X 10.6',
			'mac-os-x-5': 'Macintosh OS X 10.5',
			'mac-os-x-4': 'Macintosh OS X 10.4',
			'mac-os-x-3': 'Macintosh OS X 10.3',
			'mac-os-x-2': 'Macintosh OS X 10.2',
			'mac-os-x': 'Macintosh OS X',
			'unknown': 'Windows 10 (64bit)'
		}
	});
	documentService.constant('operatingSystems', {
		'101770': "Linux",
		'101790': "Macintosh OS X 10.2",
		'101791': "Macintosh OS X 10.3",
		'102031': 'Windows 2000',
		'102032': 'Windows 2003',
		'102035': "Windows 98",
		'102036': "Windows 98SE",
		'102037': "Windows ME",
		'102039': "Windows NT4.0",
		'102040': "Windows Server 2000",
		'102041': "Windows Server 2003",
		'102042': "Windows XP",
		'102318': "Macintosh OS X 10.4",
		'102322': "Windows Server 2003 (64bit)",
		'102323': "Windows XP(64bit)",
		'102430': "Windows Vista",
		'102431': "Windows Vista(64bit)",
		'102434': "Macintosh OS X 10.5",
		'102435': "Windows Server 2008",
		'102511': "Windows Server 2008 (64bit)",
		'102742': "Macintosh OS X 10.6",
		'102743': "Windows 7",
		'102744': "Windows 7 (64 bit)",
		'102746': "Windows Server 2008 R2 (64bit)",
		'102758': "Macintosh OS X 10.7",
		'102767': "Macintosh OS X 10.8",
		'102768': "Windows 8",
		'102769': "Windows 8 (64 bit)",
		'102770': "Windows Server 2012",
		'500665': "Macintosh OS X 10.9",
		'500666': "Windows 8.1",
		'500667': "Windows 8.1 (64bit)",
		'500668': "Windows Server 2012 R2",
		'500690': "Macintosh OS X 10.10",
		'500712': "Windows 10",
		'500713': "Windows 10 (64bit)",
		'500720': "Macintosh OS X 10.11",
		'500722': "macOS Sierra (OS X 10.12)",
        '500723': "Windows Server 2016",
		'500725': "macOS High Sierra (OS X 10.13)",
	});

	documentService.factory('DocumentService', [
		'timeout', '$timeout', 'deviceDetector', 'operatingSystems', 'osMapping', 'preferredLanguage',
		function (timeout, $timeout, deviceDetector, operatingSystems, osMapping, preferredLanguage) {

			var forEach = angular.forEach,
				preferredOS = (function () {
					// detect preferred OS =
					if (deviceDetector.os_version === 'unknown') {
						return osMapping.os[deviceDetector.os] || '';
					}
					return osMapping.os_version[deviceDetector.os_version] || '';
				}()),
				splitDocuments = function (data, translations) {
					if (!data) {
						return {};
					}
					data = data.sort(function (v1, v2) {
						var val1 = String(v1.Version_textS),
							val2 = String(v2.Version_textS);
						if (val1.search(/[a-zA-Z]/) !== -1) {
							return val1.localeCompare(val2);
						}
						var v1Arr = val1.split(/[-\._,]/),
							v2Arr = val2.split(/[-\._,]/),
							res = 0;
						for (var i = 0; i < v1Arr.length; i++) {
							res = (+v1Arr[i]) - (+v2Arr[i]);
							if (res === 0) {
								continue;
							}
							return res > 0 ? -1 : 1;
						}
						return 0;
					});
					var _splitDocuments = function (data, osSwitch) {
							var _getHash = function (document, language) {
								var hash = [
										document.TypeOfApplicationId_textS,
										language
									],
									version = document.Version_textS,
									name = (document.Name_textS || '').replace(version, '');

								switch (+document.TypeOfApplicationId_textS) {
									case 1: // Drivers
										hash.push((document.EmulationNames_textM || []).join('@'));
										hash.push(document.TypeOfDriverName_textS || '');
										break;
									case 2: // Manuals
										hash.push(document.TypeOfDocumentationId_texts || name);
										break;
									case 3: // Software Applications
										hash.push(document.FirstCategoryID_textS || name);
										hash.push(document.MainCategoryID_textS || name);
										break;
									case 4: // Firmware
										hash.push(document.TypeOfFirmwareID_textS || name);
										break;
									case 5: // Safety Documents
										hash.push(document.TypeOfSafetyDocumentId_texts || name);
										break;
									default:
										hash.push(Math.floor(Math.random() * 65536));
								}
								return hash.join('@');
							};
							if (data.length === 0) {
								return null;
							}
							// split by language and, optional, by os
							var languages, oses, documents = {}, hashes = [];
							forEach(data, function (document) {
								if (typeof document.EmulationNames_textM === 'string') {
									document.EmulationNames_textM = [document.EmulationNames_textM];
								}
								languages = [ '(not related)' ];
								if (document.LanguageNames_textM) {
									if (Object.prototype.toString.call(document.LanguageNames_textM) === "[object Array]") {
										languages = document.LanguageNames_textM;
									} else {
										languages = [ document.LanguageNames_textM ];
									}
								}
								oses = [ 'all' ];
								if (document.OperatingSystemsNames_textM) {
									if (Object.prototype.toString.call(document.OperatingSystemsNames_textM) === "[object Array]") {
										oses = document.OperatingSystemsNames_textM;
									} else {
										oses = [ document.OperatingSystemsNames_textM ];
									}
								} else {
									if (document.OperatingSystemIds_textM) {
										if (Object.prototype.toString.call(document.OperatingSystemIds_textM) === "[object Array]") {
											oses = document.OperatingSystemIds_textM.map(function (id) {
												return operatingSystems[id];
											});
										} else {
											oses = [ operatingSystems[document.OperatingSystemIds_textM] ];
										}
									}
								}

								forEach(languages, function (language) {
									language = translations[language] || language;
									documents[language] = documents[language] || (osSwitch ? {} : []);
									var hash = _getHash(document, language);
									if (osSwitch) {
										forEach(oses, function (os) {
											if (!hashes[hash + '@' + os]) {
												document.isFirst = true;
												hashes[hash + '@' + os] = true;
											}
											documents[language][os] = documents[language][os] || [];
											documents[language][os].push(document);
										});
									} else {
										if (!hashes[hash]) {
											document.isFirst = true;
											hashes[hash] = true;
										}
										documents[language].push(document);
									}
								});
							});
							return documents;
						},
						drivers = [], manuals = [], firmware = [],
						applications = [], safetyDocuments = [];

					forEach(data, function (document) {
						switch (+document.TypeOfApplicationId_textS) {
							case 1:
								drivers.push(document);
								break;
							case 2:
								manuals.push(document);
								break;
							case 3:
								applications.push(document);
								break;
							case 4:
								firmware.push(document);
								break;
							case 5:
								safetyDocuments.push(document);
								break;
						}
					});

					return {
						drivers: _splitDocuments(drivers, true),
						manuals: _splitDocuments(manuals),
						applications: _splitDocuments(applications, true),
						firmware: _splitDocuments(firmware),
						safetyDocuments: _splitDocuments(safetyDocuments)
					};
				},
				buildConcordance = function (documents, translations, type, selected, osSwitch) {
					var concordance = [], oses, systems, langItem = {}, count = 0, icount = 0, defaultLanguageItem;
					forEach(documents, function (val, language) {
						systems = [];
						if (osSwitch) {
							oses = documents[language];
							icount = 0;
							forEach(oses, function (val, os) {
								systems.push(os);
								if ((icount === 0 && !selected[type].os[language]) || os === preferredOS) {
									selected[type].os[language] = os;
								}
								icount++;
							});
						}
						langItem = {
							language: language,
							systems: systems
						};
                        if (language === 'English') {
                            defaultLanguageItem = langItem;
                        }
						concordance.push(langItem);
                        if (count === 0 || language === preferredLanguage || translations[preferredLanguage] === language) {
							selected[type].language = langItem;
						}
						count++;
					});

					// Always select english entry if no preselection for preferred language exists
					if (count > 0 && selected[type] && selected[type].language
						&& selected[type].language.language !== preferredLanguage && selected[type].language.language !== translations[preferredLanguage]
						&& defaultLanguageItem
					) {
                        selected[type].language = defaultLanguageItem;
					}

					return concordance;
				};

			return {
				splitDocuments: splitDocuments,
				buildConcordance: buildConcordance
			};
		}
	]);
}());
